import { Component, Injector, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AbstractComponent, Pager, Webhook, WebhookService } from 'lib-trend-core';
import { debounceTime, distinctUntilChanged, Observable, Subject, switchMap } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { WebhookIntegrationsRequestsViewComponent } from '../webhook-integrations-requests-view/webhook-integrations-requests-view.component';

@Component({
    selector: 'webhook-integrations-requests-component',
    templateUrl: 'webhook-integrations-requests.v2.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class WebhookIntegrationsRequestsComponent extends AbstractComponent implements OnInit {

  public pager: Pager<Webhook> = new Pager<Webhook>({ perPage: 100 });
  private listObservable: Observable<Pager<Webhook>>;
  private termOfSearch: Subject<string> = new Subject<string>();

  code: string = undefined;
  uuid: string = undefined;

  breadcrumb = [
    { href: '/integrations', label: 'integrations.breadcrumb.integrations' },
    { label: 'integrations.breadcrumb.webhookRequests' },
  ]

  constructor(
    public injector: Injector,
    public dialog: MatDialog,
    private webhookService: WebhookService
  ) {
    super(injector);
    this.loadingContent = false;
  }

  ngOnInit() {
    this.code = super.getParam('code');
    this.uuid = super.getParam('uuid');
    if (!!this.code && !!this.uuid) {
      this.getList();
    }
  }

  getList() {
    this.searchParams = { code: this.code, uuid: this.uuid };
    this.webhookService.pagerByCodeAndUUID(this.pager.page, this.pager.perPage, this.searchString, this.searchParams)
      .subscribe({
        next: (pager: Pager<Webhook>) => {
          this.pager = pager;
          this.setupObservableSearch();
        },
        complete: () => (this.loadingContent = false),
      });
  }

  setupObservableSearch() {
    this.listObservable = this.termOfSearch
      .pipe(debounceTime(500))
      .pipe(distinctUntilChanged())
      .pipe(
        switchMap((term) =>
          this.webhookService.pagerByCodeAndUUID(this.pager.page, this.pager.perPage, term, this.searchParams)
        )
      );
    this.listObservable.subscribe((pager: Pager<Webhook>) => {
      this.pager = pager;
    });
  }

  search(term: string) {
    this.pager.page = 1;
    this.searchString = term;
    this.termOfSearch.next(term);
  }

  loadPage(page: number) {
    this.pager.page = page;
    this.getList();
  }

  view(webhook: Webhook) {
    this.dialog.open(WebhookIntegrationsRequestsViewComponent, {
      width: '1000px',
      height: '800px',
      data: webhook
    });
  }

  public getWebhookIntegrationsURLbyCode(): string {
    return `${environment.trendIntegrationsUrl}/webhook/${this.code}/${this.uuid}`;
  }

  getFieldsQuery(webhook: Webhook): string[] {
    return Object.keys(webhook?.metadata?.query ?? [])?.map((key) => key) ?? [];
  }

  getFieldsBody(webhook: Webhook): string[] {
    return Object.keys(webhook?.metadata?.body ?? [])?.map((key) => key) ?? [];
  }

}
